import { gql } from "gql";

export const SAVE_ENUM_DYNAMIC_ATTRIBUTE = gql(/* GraphQL */ `
  mutation SaveEnumDynamicAttribute($attribute: EnumDynamicAttributeInput!) {
    saveEnumDynamicAttribute(attribute: $attribute)
  }
`);
